import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe} from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";
import { Icon } from '@iconify/react';
// import { SiAdobepremierepro, SiAdobeillustrator } from "react-icons/si";
// import { SiAdobeaftereffects } from "react-icons/si";
// import { SiAdobeillustrator, SiAdobeaftereffects } from "react-icons/si";
import { SiAdobepremierepro, SiAdobeillustrator, SiAdobeaftereffects } from "react-icons/si";


// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <Icon icon="skill-icons:aftereffects" width="50" height="50" />,
    title: "MOTION GRAPHIC ARTIST",
    des: "Creative and dedicated motion graphic artist with one year of experience in dynamic animations and video content.",
  },
  

  
  {
    id: 2,
    icon: <Icon icon="skill-icons:photoshop" width="50" height="50" />,
    title: "GRAPHIC DESIGNER",
    des: "Creative designer skilled in branding and marketing graphics, with expertise in Adobe Suite and a passion for innovation.",
  },
  {
    id: 3,
    icon:<Icon icon="skill-icons:illustrator" width="50" height="50" />,
    title: "Animations",
    des: "Create stunning, smooth animations that enhance user experience and bring your interfaces to life with effortless transitions and effects.",
  }

  
  // {
  //   id: 4,
  //   icon: <FaMobile />,
  //   title: "Mobile Development",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
  // {
  //   id: 5,
  //   icon: <SiAntdesign />,
  //   title: "UX Design",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
  // {
  //   id: 6,
  //   icon: <FaGlobe />,
  //   title: "Hosting Websites",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
];